import { useSetModal } from "@/shared/atoms/useModal";
import useCartItemStatusMutation from "@/shared/mutations/orders/useCartItemStatusMutation";
import { cartStatusses } from "@/shared/utils/constant";
import useLiveOrdersRefetch from "@/shared/v2/hooks/useLiveOrdersRefetch";
import { CartContent, OrderV2 } from "@/shared/v2/queries/interfacesV2";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner/Spinner";

const OrderCartStatusUpdate = ({
  item,
  order,
}: {
  item: CartContent;
  order: OrderV2;
}) => {
  const refetch = useLiveOrdersRefetch();
  const setModal = useSetModal();
  const { t } = useTranslation("");
  const update = useCartItemStatusMutation(order.order_information.branch_id);
  return (
    <div className="flex items-center gap-4">
      <select
        value={item?.kitchen_status || -1}
        onChange={(e) =>
          update
            .mutateAsync({
              order,
              kitchenScreenId: item.kitchen_screen_id.toString(),
              status: parseInt(e.target.value),
              kitchen_prep_time_in_seconds: 0,
            })
            .then(() => {
              refetch();
              setModal("");
            })
        }
        className="outline-0 py-1 px-2 border rounded-md min-w-30"
      >
        {item?.kitchen_status === undefined && (
          <option defaultChecked value={-1}>
            {t("noStatus")}
          </option>
        )}
        {cartStatusses?.map((key) => (
          <option value={key} key={key}>
            {t(`cartitemstatus${key}`)}
          </option>
        ))}
      </select>
      {update.isPending && <Spinner size="0.2rem" />}
    </div>
  );
};

export default OrderCartStatusUpdate;
